(() => {
  const SELECTOR = "[data-dpp-yotpo-lazy]";

  function addWidgetClasses(widget) {
    const classes = (widget.dataset.dppYotpoClasses || "")
      .split(" ")
      .map((className) => className.trim())
      .filter(Boolean);
    widget.classList.add(...classes);
  }

  function getYotpoLoader() {
    if (typeof window.dppLoadYotpo === "function") {
      return Promise.resolve(window.dppLoadYotpo);
    }

    return new Promise((resolve, reject) => {
      const timeout = window.setTimeout(() => {
        window.removeEventListener("dpp:yotpo-loader-ready", onReady);
        reject(new Error("The Yotpo loader was not registered."));
      }, 5000);

      function onReady() {
        window.clearTimeout(timeout);
        if (typeof window.dppLoadYotpo === "function") {
          resolve(window.dppLoadYotpo);
        } else {
          reject(new Error("The Yotpo loader is unavailable."));
        }
      }

      window.addEventListener("dpp:yotpo-loader-ready", onReady, {
        once: true,
      });
    });
  }

  async function activateWidget(widget) {
    if (widget.dataset.dppYotpoState) return;
    widget.dataset.dppYotpoState = "loading";

    try {
      const loadYotpo = await getYotpoLoader();
      await loadYotpo();
      addWidgetClasses(widget);

      if (
        widget.dataset.dppYotpoKind === "carousel" &&
        typeof window.yotpoWidgetsContainer?.initWidget === "function"
      ) {
        window.yotpoWidgetsContainer.initWidget(
          widget.dataset.yotpoInstanceId,
          widget,
        );
      } else if (typeof window.yotpo?.initWidgets === "function") {
        window.yotpo.initWidgets();
      } else if (
        typeof window.yotpoWidgetsContainer?.initWidgets === "function"
      ) {
        window.yotpoWidgetsContainer.initWidgets();
      }

      widget.dataset.dppYotpoState = "ready";
    } catch (error) {
      widget.dataset.dppYotpoState = "failed";
      console.warn("[DPP] Unable to initialize lazy Yotpo widget", error);
    }
  }

  function observeWidget(widget) {
    if (!("IntersectionObserver" in window)) {
      window.addEventListener("load", () => activateWidget(widget), {
        once: true,
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        activateWidget(widget);
      },
      {
        rootMargin: widget.dataset.dppYotpoRootMargin || "600px 0px",
      },
    );
    observer.observe(widget);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(observeWidget);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
